import React from 'react';

import RindegastosLogo from '../../assets/images/logo_rindegastos_hdr.png';
import classes from './Logo.module.css';

const Logo = (props) => (
    <div className={classes.Logo}>
        <img src={RindegastosLogo} alt="Rindegastos"/>
    </div>
);

export default Logo;